function getAppVersion() {
  return 1;
}
function getAppVersion2() {
  return 2;
}

/**
 * Path will be something like: entity.action that this action
 * has a path to send and method to send.
 */

/**
 * Actions will be add, delete, update, get
 */
const GET = "get";
const POST = "post";
const PUT = "put";
const DELETE = "delete";

const addresses = {
  wholeApp: {
    get: {
      path: "/web_data",
      method: GET
    }
  },
  users: {
    get: {
      path: "/user",
      method: GET
    }
  },
  login: {
    put: {
      path: "/login",
      method: PUT
    },
    get: {
      path: "/login",
      method: GET
    },
    post: {
      path: "/login",
      method: POST
    },
    delete: {
      path: "/login",
      method: DELETE
    }
  },
  templates: {
    get: {
      path: "/template",
      method: GET
    },
    create: {
      path: "/template",
      method: POST
    },
    edit: {
      path: "/template",
      method: PUT
    },
    delete: {
      path: "/template",
      method: DELETE
    }
  },
  expressions: {
    get: {
      path: "/expression",
      method: GET
    },
    create: {
      path: "/expression",
      method: POST
    },
    edit: {
      path: "/expression",
      method: PUT
    },
    delete: {
      path: "/expression",
      method: DELETE
    }
  },
  user: {
    logCreate: {
      path: "/user_log",
      method: POST
    },
    logUpdate: {
      path: "/user_log",
      method: PUT
    },
    getSignature: {
      path: "/signature",
      method: GET
    },
  },
  patient: {
    add: {
      path: "/patient_study",
      method: POST
    }
  },
  audio: {
    create: {
      path: "/report_voice",
      method: POST
    }
  },
  hospital: {
    get: {
      path: "/hospital",
      method: GET
    }
  },
  study: {
    get: {
      path: "/study",
      method: GET
    },
    getInfo: {
      path: "/patient_study",
      method: GET
    },
    search: {
      path: "/study_search",
      method: GET
    },
    updateFromHIS: {
      path: "/his_request",
      method: PUT
    }
  },
  exports: {
    begin: {
      path: "/export/begin",
      method: POST
    },
    status: {
      path: "/export/status",
      method: GET
    },
  },
  report:{
    get: {
      path: "/report",
      method: GET
    },
    post: {
      path: "/report",
      method: POST
    },
    put: {
      path: "/report",
      method: PUT
    },
  },
  study_filters:{
    post: {
      path: "/study_filter",
      method: POST
    },
    edit: {
      path: "/study_filter",
      method: PUT
    },
    delete: {
      path: "/study_filter",
      method: DELETE
    }
  },
  structural_report: {
    get:{
      path: "/structural_report",
      method: GET
    }
  },
  spell_check: {
    post:{
      path: "/spell_check",
      method: POST
    }
  },
  net_speed: {
    get:{
	  path: "/net_speed",
	  method: GET
    },
    send:{
	  path: "/net_speed",
	  method: PUT
    }
  },
  ai: {
    get:{
	  path: "/ai",
	  method: GET
    },
    send:{
	  path: "/ai",
	  method: POST
    },
    status:{
	  path: "/ai",
	  method: GET
    }
  },
  barcode: {
    post:{
      path: "/barcode",
      method: POST
    }
  }
};

function getUrlAndMethod(entity = null, action = null) {
  if (!entity || !action) {
    throw new Error("Wrong getURL method parameters!!!");
  }

  return {
    url: `${getAppVersion()}${addresses[entity][action]["path"]}`,
    method: addresses[entity][action]["method"]
  };
}
function getUrlAndMethodv2(entity = null, action = null) {
  if (!entity || !action) {
    throw new Error("Wrong getURL method parameters!!!");
  }

  return {
    url: `${getAppVersion2()}${addresses[entity][action]["path"]}`,
    method: addresses[entity][action]["method"]
  };
}


export {getUrlAndMethod, getUrlAndMethodv2};
